module.exports = {
      id: "ic-150-index-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite-ad374a.smartcharts.svg#ic-150-index-usage",
      toString: function () {
        return this.url;
      }
    }